export default {
  build: 'mq-e12f7bd',
  builtAt: '1793850149',
};
